import { HOSTED_APP_CHANNEL } from "../../branding";
import { ForgeWordmark } from "../branding/ForgeWordmark";

export function PairingRouteHeading() {
  return (
    <>
      {HOSTED_APP_CHANNEL ? (
        <div className="mb-5">
          <ForgeWordmark variant="auth" showStageBadge />
        </div>
      ) : null}
      <h1 className="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">Log in</h1>
    </>
  );
}
